(function () {
  'use strict';

  var EVENT_NAME = 'link_click_related_content';
  var LOCATION = 'product_related_articles';

  function track(params) {
    if (typeof window.gtag === 'function') {
      window.gtag('event', EVENT_NAME, params || {});
    }
  }

  function bind(root) {
    if (!root || root.getAttribute('data-related-bound') === 'true') return;
    root.setAttribute('data-related-bound', 'true');

    root.addEventListener('click', function (event) {
      var card = event.target.closest('a.story-product-related-articles__card');
      if (!card || !root.contains(card)) return;

      track({
        item_id: root.getAttribute('data-item-id') || '',
        item_name: root.getAttribute('data-item-name') || '',
        item_category: root.getAttribute('data-item-category') || '',
        location: LOCATION,
        link_url: card.getAttribute('href') || '',
        content_type: card.getAttribute('data-content-type') || '',
        content_id: card.getAttribute('data-content-id') || ''
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-facett-product-related]').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (!event.target) return;
    var root = event.target.querySelector('[data-facett-product-related]');
    if (root) bind(root);
  });
})();
